import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import format from "date-fns/format";
import { useMemo } from "react";
import { useGetPatientWeightQuery } from "src/api/services/weightTrackerApi";
import UpdateVitalsModal from "../Modals/UpdateVitalsModal";
import { useManageModal } from "src/hooks/useManageModal";
import { IconButton } from "@mui/material";
import { Edit } from "@mui/icons-material";
import AddNewWeightModal from "../Modals/AddNewWeightModal";
import { PatientWeight } from "src/api/types";

const formatHeight = (height: number) => {
  return `${Math.floor(height / 12)}'${height % 12}`;
};

interface Props {
  patientId: number;
}

const PatientVitals = ({ patientId }: Props) => {
  const [open, { handleClose, handleOpen }] = useManageModal();
  const [
    openCreate,
    { handleClose: handleCloseCreate, handleOpen: handleOpenCreate },
  ] = useManageModal();
  const { data: weights = [] } = useGetPatientWeightQuery(patientId);

  const vitals = useMemo(() => {
    if (weights.length === 0) return null;

    const height = weights[weights.length - 1].height ?? "N/A";
    const starting = weights[weights.length - 1] ?? "N/A";
    let recent: PatientWeight | null = null;

    if (weights.length > 1) {
      recent = weights[0];
    }

    return { height, starting, recent };
  }, [weights]);

  if (vitals == null) return null;

  return (
    <>
      <Stack>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          height={34}
        >
          <Typography fontWeight={700}>Vitals</Typography>

          <IconButton size="small" onClick={handleOpen}>
            <Edit />
          </IconButton>
        </Stack>
        <Typography>
          Added: {format(new Date(vitals.starting.created_at), "MM/d/yyyy")}
        </Typography>
        <Typography>Height: {formatHeight(vitals.height)}</Typography>
        <Typography>Starting weight: {vitals.starting.weight}(lbs)</Typography>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography>
            Most recent weight:{" "}
            {vitals.recent !== null ? `${vitals.recent.weight}(lbs)` : null}
          </Typography>
          <IconButton size="small" onClick={handleOpenCreate}>
            <Edit />
          </IconButton>
        </Stack>
        <Typography>Weight Loss Goal: {vitals.starting.goal}(lbs)</Typography>
        <Typography>BMI: {vitals.starting.bmi}</Typography>
      </Stack>
      <UpdateVitalsModal
        open={open}
        onClose={handleClose}
        vitals={vitals.starting}
      />
      <AddNewWeightModal
        open={openCreate}
        onClose={handleCloseCreate}
        vitals={vitals.starting}
      />
    </>
  );
};

export default PatientVitals;
